/**
 * @generated SignedSource<<f9bd0998820945805c91509a3fef42e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDeleteEmployeeRoleAlertMutation$variables = {
  id: string;
};
export type useDeleteEmployeeRoleAlertMutation$data = {
  readonly store: {
    readonly employeeRole: {
      readonly delete: {
        readonly deletedRoleId: string | null;
        readonly success: boolean;
      };
    } | null;
  };
};
export type useDeleteEmployeeRoleAlertMutation = {
  response: useDeleteEmployeeRoleAlertMutation$data;
  variables: useDeleteEmployeeRoleAlertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedRoleId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteEmployeeRoleAlertMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EmployeeRoleMutation",
            "kind": "LinkedField",
            "name": "employeeRole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DeleteEmployeeRolePayload",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteEmployeeRoleAlertMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "EmployeeRoleMutation",
            "kind": "LinkedField",
            "name": "employeeRole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DeleteEmployeeRolePayload",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteRecord",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedRoleId"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba43132eb02a9cf70b555a5379e18c33",
    "id": null,
    "metadata": {},
    "name": "useDeleteEmployeeRoleAlertMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteEmployeeRoleAlertMutation(\n  $id: ID!\n) {\n  store {\n    employeeRole(id: $id) {\n      delete {\n        success\n        deletedRoleId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc5df0a8c24abc10da23362e316f9baf";

export default node;
